import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PairSection from "../partials/exchange/PairSection";
import ProfitLoseTable from "../partials/exchange/ProfitLoseTable";
import MarketTrade from "../partials/exchange/MarketTrade";
import ExchangeTypeTicker from "../partials/exchange/exchangeTypeTicker";
import OpenOrders from "../partials/exchange/OpenOrders";
import PredictionBuyOrder from "../partials/exchange/PredictionBuyOrder";
import Ticker from "../partials/exchange/Ticker";
import Loading from "../layout/Loading";
import { toast, Toaster } from "react-hot-toast";
import TradingViewWidget, { Themes } from "react-tradingview-widget";
import * as myConstList from "../../BaseUrl";
import MetaTags from "react-meta-tags";
import socketIOClient from "socket.io-client";
import moment from "moment";
import zlib from "zlib";
// const ccxt = require("ccxt");
const baseUrl = myConstList.baseUrl;
const jwtToken = localStorage.getItem("jwtToken");
const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};

class PridictionExchange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      allCloseOrder: [],
      allOpenOrder: [],
      allAccount: [],
      portfoliototal: 0,
      PortfolioValue: 0,
      pairType: this.props.match.params.symbol.replace("-", ""),
      pair: [],
      virtualFund: 0,
      isLoaded: false,
      contestId: this.props.match.params.id,
      symbol: this.props.match.params.symbol.replace("-", ""),
      virtualFundassign: 0,
      CurrencyValue: 0,
      currentprice: 0,
      currentprice1: 0,
      tempArrPair: [],
      flagPairData: "1",
      expriryDateTime: "",
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      themeSet: "",
      exchangeType: this.props.match.params.exchangetype,
      getOrderByIdData: [],
      leaderboard: [],
    };

    this.tradesCount = 10;
    this.streams = ["@ticker", "@depth20", "@trade"];
    // this.getData = this.getData.bind(this);
  }

  // ================ Binnace Exchnage ======================
  _connectSocketStreams(streams) {
    streams = streams.join("/");
    let connection = btoa(streams);
    this[connection] = new WebSocket(
      `wss://stream.binance.com:9443/stream?streams=${streams}`
    );
    // console.log("connection===",streams);
    this[connection].onmessage = (evt) => {
      // console.log("eventData.data==bbbbbbbbbb",evt);
      let eventData = JSON.parse(evt.data);
      if (eventData.stream.endsWith("@ticker")) {
        eventData.data.lastc = this.state.ticker ? this.state.ticker.c : 0;
        // console.log("eventData.data==",eventData.data);
        this.props.dispatch({
          type: "SET_TICKER",
          data: eventData.data,
        });
        this.setState({
          loadedTicker: true,
        });
      }
      if (eventData.stream.endsWith("@trade")) {
        if (this.props.trades && Object.keys(this.props.trades).length > 0) {
          let trades = this.props.trades;
          trades.push(eventData.data);
          trades = trades.slice(-1 * this.tradesCount);
          this.props.dispatch({
            type: "SET_TRADES",
            data: trades,
          });
          this.setState({
            loadedTrades: true,
          });
        }
      }
      if (eventData.stream.endsWith("@depth20")) {
        this.props.dispatch({
          type: "SET_DEPTH",
          data: eventData.data,
        });
        this.setState({
          loadedDepth: true,
        });
      }
      this.setState({
        isLoaded: true,
      });
    };
    this[connection].onerror = (evt) => {
      console.error("onerroronerror", evt);
    };
  }
  _disconnectSocketStreams(streams) {
    streams = streams.join("/");
    let connection = btoa(streams);
    if (this[connection].readyState == WebSocket.OPEN) {
      this[connection].close();
    }
  }
  // ===================================================
  // ================== Huobi Exchange =================================
  _connectHuobiSockettream = (pair) => {
    console.log("pair====", pair);
    // pair ='xrpusdt';
    // if (this.binanceWebSocket) {
    // this.binanceWebSocket.close();
    // }
    // if (this.gateIoWebSocket) {
    // this.gateIoWebSocket.close();
    // }
    // if (this.oksSocket) {
    // this.oksSocket.close();
    // }
    // if (this.huobiSocket) {
    // this.huobiSocket.close();
    // }

    try {
      let heartbeatIntervalId = null; // Variable to store the interval ID for heartbeat
      const establishConnection = () => {
        this.huobiSocket = new WebSocket("wss://api.huobi.pro/ws");
        this.huobiSocket.onopen = () => {
          console.log(`WebSocket connection established for ${pair}.`);
          // startHeartbeatInterval();

          this.huobiSocket.send(
            JSON.stringify({
              sub: `market.${pair}.ticker`,
              id: `${pair}-trade`,
            })
          );

          // Subscribe to market depth updates for the trading pair
          this.huobiSocket.send(
            JSON.stringify({
              sub: `market.${pair}.depth.step1`,
              id: `${pair}-depth`,
            })
          );
        };

        this.huobiSocket.onmessage = async (event) => {
          var collectThis = this;
          const compressedData = new Uint8Array(await event.data.arrayBuffer());

          zlib.gunzip(compressedData, async (err, decompressedData) => {
            if (err) {
              console.error("Error decompressing data:", err);
              return;
            }

            const jsonData = decompressedData.toString("utf-8");
            // console.log("Decompressed data:", jsonData);

            try {
              const parsedData = JSON.parse(jsonData);
              if (parsedData.ping) {
                const timestamp = parsedData.ping;
                this.huobiSocket.send(JSON.stringify({ pong: timestamp })); // Send a "pong" response with the same timestamp
              }
              if (
                parsedData.ch === `market.${pair}.ticker` &&
                parsedData.tick
              ) {
                const tradeData = parsedData.tick;
                let data = await this.constructDataHuobi(tradeData);
                let mainData = {
                  topBarData: data,
                };
                this.setState({ livPrice: data.close });
                var topBarData = mainData.topBarData;
                this.props.dispatch({
                  type: "SET_TICKER",
                  data: topBarData,
                });
                // console.log("data.lastPricedata.lastPrice==",data.last);
                collectThis.setState({
                  loadedTicker: true,
                  currentprice1: data.last,
                });
              }
              if (parsedData.ch === `market.${pair}.depth.step1`) {
                const depthData = parsedData.tick;
                const reversedAsks = depthData.asks
                  .slice()
                  .sort((a, b) => a[0] - b[0]); // Sort the "asks" array in descending order based on the first element of each sub-array
                // console.log("reversedAsks",reversedAsks)
                this.props.dispatch({
                  type: "SET_DEPTH",
                  data: depthData,
                });
                collectThis.setState({
                  loadedDepth: true,
                  isLoaded: true,
                  loadedTrades: true,
                });
                // Handle the huobiTickers data as needed
              }
            } catch (error) {
              console.error("Error parsing JSON:", error);
            }
          });
        };

        this.huobiSocket.onclose = () => {
          console.log(`WebSocket connection closed for ${pair}.`);
        };
      };

      // Function to start the heartbeat interval
      const startHeartbeatInterval = () => {
        if (!heartbeatIntervalId) {
          heartbeatIntervalId = setInterval(() => {
            const timestamp = Date.now();
            this.huobiSocket.send(JSON.stringify({ ping: timestamp })); // Send a "ping" heartbeat message
          }, 5000); // Heartbeat interval of 5 seconds (same as server)
        }
      };

      // Function to stop the heartbeat interval
      const stopHeartbeatInterval = () => {
        console.log("calling");
        clearInterval(heartbeatIntervalId);
        heartbeatIntervalId = null;
      };

      establishConnection(); // Initial connection establishment
    } catch (error) {
      console.log("err2", error);
    }
  };
  constructDataHuobi = async (obj) => {
    const change = obj.close - obj.open;

    const changePercentage = (change / obj.open) * 100;

    function formatValue(value) {
      if (value < 1) {
        return value.toFixed(2);
      } else if (value >= 1) {
        return value.toFixed(2);
      } else {
        return value;
      }
    }
    const lastPrice = parseFloat(obj.lastPrice);
    // const decimalPerPrice = change < 1 ? 5 : 2;
    // const formatedPrice = change.toLocaleString("em-US", {
    //   minimumFractionDigits: decimalPerPrice,
    //   maximumFractionDigits: decimalPerPrice,
    // });
    // console.log('formatedPrice',formatedPrice,change)
    const formattedValue1 = formatValue(change);
    const formattedValue2 = formatValue(changePercentage);

    // Calculate change percentage
    return {
      // symbol: 'GARI/USDT',
      symbol: this.state.symbol,
      timestamp: 1691735520007,
      // datetime: '2023-08-11T06:32:00.007Z',
      high: obj.high,
      low: obj.low,
      bid: obj.bid,
      bidVolume: undefined,
      ask: obj.ask,
      askVolume: undefined,
      vwap: 0.01890364852187239,
      open: obj.open,
      close: obj.lastPrice,
      last: obj.lastPrice,
      previousClose: undefined,
      change: formattedValue1,
      percentage: formattedValue2,
      average: 0.019096,
      baseVolume: 96968.29824671525,
      quoteVolume: obj.amount,
      info: {
        id: 410893547,
        low: obj.low,
        high: obj.high,
        open: obj.open,
        last: obj.lastPrice,
        close: obj.lastPrice,
        vol: obj.amount,
        amount: 96968.29824671525,
        version: 410893547,
        count: 77,
      },
      // close: obj.lastPrice,
      // change: formattedValue1,
      // high: obj.high,
      // low: obj.low,
      // quoteVolume: obj.vol,
      // percentage: formattedValue2,
      // open: obj.open,
      // bid: obj.bid,
      // ask: obj.ask,
      // volume: obj.amount,
      // firstCoinVolume: obj.amount,
    };
  };
  // ===================================================================
  // ================== OKX Exchange =================================
  _connectOkxSocketStream = (pairs) => {
    // if (this.binanceWebSocket) {
    //   this.binanceWebSocket.close();
    // }
    // if (this.gateIoWebSocket) {
    //   this.gateIoWebSocket.close();
    // }
    // if (this.oksSocket) {
    //   this.oksSocket.close();
    // }
    // if (this.huobiSocket) {
    //   this.huobiSocket.close();
    // }
    this.props.dispatch({
      type: "SET_TRADES",
      data: [],
    });
    this.props.dispatch({
      type: "SET_DEPTH",
      data: [],
    });
    this.props.dispatch({
      type: "SET_TICKER",
      data: [],
    });

    try {
      this.oksSocket = new WebSocket(`wss://ws.okex.com:8443/ws/v5/public`);
      this.oksSocket.onopen = async (evtData) => {
        console.log(`WebSocket connection established for ${pairs}.`);
        // Subscribe to ticker updates for the trading pair
        this.oksSocket.send(
          JSON.stringify({
            op: "subscribe",
            args: [
              {
                channel: "tickers",
                instId: pairs,
              },
            ],
          })
        );

        this.oksSocket.send(
          JSON.stringify({
            op: "subscribe",
            args: [
              {
                channel: "books5",
                instId: pairs,
              },
            ],
          })
        );
      };
      this.oksSocket.onmessage = async (evt) => {
        const message = JSON.parse(evt.data);
        const channel = message.arg.channel;
        // console.log("channel",channel)
        console.log("message.data==", message.data);
        if (channel === "tickers" && message.data !== undefined) {
          const ticker = message.data[0];
          const data = await this.constructDataOkx(ticker);
          //   console.log("data==",data);
          let mainData = {
            topBarData: data,
          };
          var topBarData = mainData.topBarData;
          this.props.dispatch({
            type: "SET_TICKER",
            data: data,
          });
          this.setState({
            loadedTicker: true,
            currentprice1: data.last,
          });
        }
        if (channel === "books5" && message.data != undefined) {
          const dataObject = message.data[0];

          // Extract the asks and bids arrays
          const asks = dataObject.asks;
          const bids = dataObject.bids;

          // Determine the desired length for asks and bids (e.g., 10)
          const desiredLength = 20;

          // Duplicate the last entry in asks and bids to increase their lengths
          while (asks.length < desiredLength) {
            asks.push([...asks[asks.length - 1]]);
          }

          while (bids.length < desiredLength) {
            bids.push([...bids[bids.length - 1]]);
          }

          // Transform the data values within asks and bids arrays
          for (let i = 0; i < asks.length; i++) {
            asks[i] = asks[i].map(parseFloat);
          }

          for (let i = 0; i < bids.length; i++) {
            bids[i] = bids[i].map(parseFloat);
          }

          // Update the modified asks and bids arrays in the message
          dataObject.asks = asks;
          dataObject.bids = bids;

          this.props.dispatch({
            type: "SET_DEPTH",
            data: dataObject,
          });
          this.setState({
            loadedDepth: true,
            isLoaded: true,
            loadedTrades: true,
          });
          //   console.log("dataObject========",dataObject);
          // Print the modified message
          // console.log(JSON.stringify(message, null, 2));
        }
      };
    } catch (error) {
      console.log("err2", error);
    }
  };
  constructDataOkx = (obj) => {
    const percentage = ((obj.last - obj.open24h) / obj.open24h) * 100;
    return {
      symbol: this.state.symbol,
      timestamp: 1691735520007,
      // datetime: '2023-08-11T06:32:00.007Z',
      high: obj.high24h,
      low: obj.low24h,
      bid: obj.bid,
      bidVolume: undefined,
      ask: obj.ask,
      askVolume: undefined,
      vwap: obj.volCcy24h,
      open: obj.open,
      close: obj.last,
      last: obj.last,
      previousClose: undefined,
      change: (parseFloat(obj.last) - parseFloat(obj.open24h)).toFixed(3),
      percentage: percentage.toFixed(2),
      average: 0.019096,
      baseVolume: obj.volCcy24h,
      quoteVolume: obj.volCcy24h,
      info: {
        id: 410893547,
        low: obj.low,
        high: obj.high,
        open: obj.open,
        last: obj.last,
        close: obj.last,
        vol: obj.amount,
        amount: obj.volCcy24h,
        version: 410893547,
        count: 77,
      },
    };
  };
  // ===================================================================

  // ================= Karken Exchnage ========================
  _connectKarkenSocketStream = (pairs) => {
    // if (this.binanceWebSocket) {
    //   this.binanceWebSocket.close();
    // }
    // if (this.gateIoWebSocket) {
    //   this.gateIoWebSocket.close();
    // }
    // if (this.karkenSocket) {
    //   this.karkenSocket.close();
    // }
    // if (this.huobiSocket) {
    //   this.huobiSocket.close();
    // }
    this.props.dispatch({
      type: "SET_TRADES",
      data: [],
    });
    this.props.dispatch({
      type: "SET_DEPTH",
      data: [],
    });
    this.props.dispatch({
      type: "SET_TICKER",
      data: [],
    });

    try {
      this.karkenSocket = new WebSocket(`wss://ws.kraken.com`);
      this.karkenSocket.onopen = async (evtData) => {
        console.log(`WebSocket connection established for ${pairs}.`);
        // Subscribe to ticker updates for the trading pair
        this.karkenSocket.send(
          JSON.stringify({
            event: "subscribe",
            pair: [pairs], // Replace with the trading pair you're interested in
            subscription: {
              name: "ticker",
            },
          })
        );

        this.karkenSocket.send(
          JSON.stringify({
            event: "subscribe",
            pair: [pairs], // Replace with the trading pair you're interested in
            subscription: {
              name: "book",
              depth: 10, // Replace with the desired depth level
            },
          })
        );
        this.karkenSocket.send(
          JSON.stringify({
            event: "subscribe",
            pair: [pairs], // Replace with the trading pair you're interested in
            subscription: {
              name: "spread",
              depth: 10, // Replace with the desired depth level
            },
          })
        );
      };
      this.karkenSocket.onmessage = async (evt) => {
        const message = JSON.parse(evt.data);
        const channel = message.channelName;
        // console.log("channel",channel)
        if (channel === "ticker" && message[1] !== undefined) {
          const ticker = message[1];
          const data = await this.constructDataKarken(ticker);
          //   let mainData = {
          //     topBarData: data,
          //   };
          //   var topBarData = mainData.topBarData;
          this.props.dispatch({
            type: "SET_TICKER",
            data: data,
          });
          this.setState({
            loadedTicker: true,
            currentprice1: data.last,
          });
        }
        if (channel === "book" && message != undefined) {
          const dataObject = message.data;

          // Extract the asks and bids arrays
          const asks = dataObject.asks;
          const bids = dataObject.bids;

          // Determine the desired length for asks and bids (e.g., 10)
          const desiredLength = 10;

          // Duplicate the last entry in asks and bids to increase their lengths
          while (asks.length < desiredLength) {
            asks.push([...asks[asks.length - 1]]);
          }

          while (bids.length < desiredLength) {
            bids.push([...bids[bids.length - 1]]);
          }

          // Transform the data values within asks and bids arrays
          for (let i = 0; i < asks.length; i++) {
            asks[i] = asks[i].map(parseFloat);
          }

          for (let i = 0; i < bids.length; i++) {
            bids[i] = bids[i].map(parseFloat);
          }

          // Update the modified asks and bids arrays in the message
          dataObject.asks = asks;
          dataObject.bids = bids;

          console.log("message", message);
          this.props.dispatch({
            type: "SET_DEPTH",
            data: dataObject,
          });
          this.setState({
            loadedDepth: true,
            isLoaded: true,
            loadedTrades: true,
          });
          //   console.log("dataObject========",dataObject);
          // Print the modified message
          // console.log(JSON.stringify(message, null, 2));
        }
      };
    } catch (error) {
      console.log("err2", error);
    }
  };
  constructDataKarken = (obj) => {
    const percentage = ((obj.last - obj.open24h) / obj.open24h) * 100;
    return {
      symbol: this.state.symbol,
      timestamp: 1691735520007,
      // datetime: '2023-08-11T06:32:00.007Z',
      high: obj.high24h,
      low: obj.low24h,
      bid: obj.bid,
      bidVolume: undefined,
      ask: obj.ask,
      askVolume: undefined,
      vwap: obj.volCcy24h,
      open: obj.open,
      close: obj.last,
      last: obj.last,
      previousClose: undefined,
      change: (parseFloat(obj.last) - parseFloat(obj.open24h)).toFixed(3),
      percentage: percentage.toFixed(2),
      average: 0.019096,
      baseVolume: obj.volCcy24h,
      quoteVolume: obj.volCcy24h,
      info: {
        id: 410893547,
        low: obj.low,
        high: obj.high,
        open: obj.open,
        last: obj.last,
        close: obj.last,
        vol: obj.amount,
        amount: obj.volCcy24h,
        version: 410893547,
        count: 77,
      },
    };
  };
  //   ===============================================================

  getData = () => {
    const { user } = this.props.auth;

    const socket = socketIOClient(baseUrl, {
      query:
        "jwtToken=" +
        jwtToken +
        "&contestId=" +
        this.state.contestId +
        "&symbol=" +
        this.props.match.params.symbol +
        "&exchangetype=" +
        this.props.match.params.exchangetype +
        "&&contestType=price",
    });

    this.setState({ socketCollect: socket });
    var collectThis = this;

    // client-side
    socket.on("connect", () => {
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("callExchangeData");
      // console.log("CallExchnageData===");
    });

    socket.on("contestByIdData", function (apiRespData) {
      // console.log("apiRespData===",apiRespData.data.item.endDate);
      if (socket.id == collectThis.state.currentSocketId) {
        // const tempEndDateTime = apiRespData.data.item.endDate + " " + apiRespData.data.item.endTime;
        const tempEndDateTime = apiRespData.data.item.endDate;
        // console.log("apiRespData.data.pair===",apiRespData.data.pair);
        collectThis.setState({
          records: apiRespData.data.item,
          virtualFundassign: apiRespData.data.item.virtualFund,
          expriryDateTime: tempEndDateTime,
          tempArrPair: apiRespData.data.item.pair_id,
          pair: apiRespData.data.pair,
        });
      }
    });

    socket.on("serverTime", function (apiRespData) {
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({ serverTime: apiRespData });
      }
    });

    socket.on("getOrderByIdData", function (apiRespData) {
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({ getOrderByIdData: apiRespData.data });
      }
    });

    socket.on("participateByIdData", function (apiRespData) {
      // console.log("apiRespData----",apiRespData);
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({ virtualFund: apiRespData.data.virtualFund });
      }
    });

    socket.on("getAccountData", function (apiRespData) {
      // console.log("getAccountData==",apiRespData);
      if (apiRespData.data) {
        if (socket.id == collectThis.state.currentSocketId) {
          var arrnew = [];
          var total = 0;
          var portfoliototal = apiRespData.data.total;
          if (apiRespData.data.total === undefined) {
            portfoliototal = 0;
          }
          collectThis.setState({
            allAccount: apiRespData.data.allAccount,
            portfoliototal: portfoliototal,
          });
        }
      }
    });

    // socket.on("crptoPriceData", function (apiRespData) {
    //     if (socket.id == collectThis.state.currentSocketId) {
    //         collectThis.setState({
    //             currentprice: apiRespData.price,
    //         });
    //     }
    // })

    socket.on("leaderboardWithOrderData", function (apiRespData) {
      // console.log("apiRespData.data=========Prediction",apiRespData.data);
      if (socket.id == collectThis.state.currentSocketId) {
        collectThis.setState({
          leaderboard: apiRespData.data,
          leaderboardPaticipants: apiRespData.data,
        });
      }
    });

    // huobi exchange

    if (this.props.match.params.exchangetype !== "BINANCE") {
      // this.props.match.params.symbol+ "&exchangetype=" + this.props.match.params.exchangetype
      console.log(
        "this.props.match.params.exchangetype==",
        this.props.match.params.exchangetype
      );
      var exhngaeTypesymbol = this.props.match.params.symbol.toUpperCase();
      exhngaeTypesymbol = exhngaeTypesymbol.replace("-", "");
      let exhngaeTypesymbol2 = this.props.match.params.symbol.replace("-", "/");
      // exhngaeTypesymbol = "ETH/USDT";
      var exchnage = "";
      if (this.props.match.params.exchangetype === "HUOBI") {
        this._connectHuobiSockettream(exhngaeTypesymbol.toLowerCase());
      } else if (this.props.match.params.exchangetype === "OKX") {
        // exchnage = new ccxt.okx();
        console.log(
          "exhngaeTypesymbol===",
          this.props.match.params.symbol.toUpperCase()
        );
        this._connectOkxSocketStream(
          this.props.match.params.symbol.toUpperCase()
        );
      } else if (this.props.match.params.exchangetype === "KRAKEN") {
        // exchnage = new ccxt.kraken();
        // this._connectKarkenSocketStream(exhngaeTypesymbol2.toUpperCase());
      } else if (this.props.match.params.exchangetype === "LBANK") {
        // exchnage = new ccxt.lbank();
      }

      // setInterval(async () => {
      //     console.log("exchnageDat=====================",exchnage);
      //     // console.log ("exchnageCompleteData",exchnage.id,  await exchnage.fetchTrades ('ETH/USDT'))
      //     const tikerData = await exchnage.fetchTicker(exhngaeTypesymbol);
      //     console.log("tikerData===",tikerData);
      //     // tiker data
      //     collectThis.props.dispatch({
      //         type: 'SET_TICKER',
      //         data: tikerData
      //     })
      //     collectThis.setState({
      //         loadedTicker: true,
      //         currentprice1:tikerData.last
      //     })
      //     //
      //     // fetchOrderBook
      //     let binanceDepth = await exchnage.fetchOrderBook(exhngaeTypesymbol);
      //     collectThis.props.dispatch({
      //         type: 'SET_DEPTH',
      //         data: binanceDepth
      //     })
      //     collectThis.setState({
      //         loadedDepth: true
      //     })
      //     //
      //     // fetchTrades
      //     let fetchTrades = await exchnage.fetchTrades(exhngaeTypesymbol);
      //     collectThis.props.dispatch({
      //         type: 'SET_TRADES',
      //         data: fetchTrades
      //     })
      //     collectThis.setState({
      //         isLoaded: true,
      //         loadedTrades: true
      //     })
      //     //
      // }, 1000);

      // let exchnageType = this.props.match.params.exchangetype.toLowerCase();
      // let exhngaeTypesymbol = this.props.match.params.symbol.toUpperCase();
      // exhngaeTypesymbol = exhngaeTypesymbol.replace("-","");
      // let contestId = this.props.match.params.id;
      // let socketNameTicker = contestId+exchnageType+exhngaeTypesymbol+"ticker";
      // let socketNameDepth = contestId+exchnageType+exhngaeTypesymbol+"depth";
      // let socketNameTrades = contestId+exchnageType+exhngaeTypesymbol+"trades";

      // console.log("socketNameTicker===",socketNameTicker);
      // socket.on(socketNameTicker, function (apiRespData) {
      //     // console.log("tickerDataexchnage.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_TICKER',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         loadedTicker: true,
      //         currentprice1:apiRespData.data.lastPrice
      //     })
      // })
      // socket.on(socketNameDepth, function (apiRespData) {
      //     // console.log("depthData.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_DEPTH',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         loadedDepth: true
      //     })
      // })
      // socket.on(socketNameTrades, function (apiRespData) {
      //     // console.log("tradesData.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_TRADES',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         isLoaded: true,
      //         loadedTrades: true
      //     })
      // })
      // socket.on("tickerData", function (apiRespData) {
      //     console.log("tickerData.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_TICKER',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         loadedTicker: true,
      //         currentprice1:apiRespData.data.last
      //     })
      // })
      // socket.on("depthData", function (apiRespData) {
      //     console.log("depthData.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_DEPTH',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         loadedDepth: true
      //     })
      // })
      // socket.on("tradesData", function (apiRespData) {
      //     console.log("tradesData.data=========",apiRespData.data);
      //     collectThis.props.dispatch({
      //         type: 'SET_TRADES',
      //         data: apiRespData.data
      //     })
      //     collectThis.setState({
      //         isLoaded: true,
      //         loadedTrades: true
      //     })

      // })
    }
    // end
  };
  parseDate = (date) => {
    const parsed = date;
    if (!isNaN(parsed)) {
      return parsed;
    }
    // console.log('datedatedatedatedatedate', date, parsed)
    return parsed(date && date.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
  };
  getPortfolioData = () => {
    // timer set
    var expriry = this.state.expriryDateTime;
    var dateformat = this.state.serverTime;
    var currentDate = dateformat;
    // var expriry1 = Date.parse(expriry);
    var expriry1 = moment(String(expriry));
    // expriry = expriry.toString();
    var expriry2 = expriry1;

    var expriry3 = expriry2 / 1000;
    // currentDate = Date.parse(currentDate);
    var currentDate1 = moment(String(currentDate));
    // currentDate = currentDate.toString();
    // currentDate = this.parseDate(currentDate);
    // console.log('currentDate', currentDate1)
    var currentDate2 = currentDate1 / 1000;
    const countdown = moment(expriry3 - currentDate2);
    var duration = moment.duration(countdown * 1000, "milliseconds");
    var interval = 1000;
    duration = moment.duration(duration - interval, "milliseconds");

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const symbol1 = this.props.symbol;
    this.setState({ days, hours, minutes, seconds });
    if (seconds <= 0) {
      clearInterval(interval);
    }
    if (
      days <= 0 &&
      minutes <= 0 &&
      hours <= 0 &&
      seconds <= 0 &&
      this.state.modalOnOff == "0"
    ) {
      this.state.modalOnOff = "1";
      // timeout process API
      // console.log("this.state.contestId=", this.state.contestId);
      var collectThis = this;
      const socket = socketIOClient(baseUrl, {
        query: "jwtToken=" + jwtToken + "&contestId=" + this.state.contestId,
      });

      this.setState({ socketCollect: socket });
      socket.on("connect", () => {
        // console.log("dashboardSocket==");
        collectThis.setState({ currentSocketId: socket.id });
        socket.emit("timeOutProcess");
      });
      //
      this.openTimerModal();
      setTimeout(function () {
        // window.location.href = window.location.pathname;
        window.location.href = "/dashboard";
      }, 2000);
    }
    // timer end
  };
  componentDidMount() {
    this.setState({ themeSet: localStorage.getItem("theme") });
    let symbolType = this.props.match.params.symbol.replace("-", "");
    if (this.state.contestId && symbolType) {
      this.intervalExchnge = setInterval(() => {
        this.getPortfolioData();
      }, 1000);
    } else {
      clearInterval(this.intervalExchnge);
    }
    let symbol = this.props.match.params.symbol.toLowerCase();
    let exchangeType = this.props.match.params.exchangetype;
    symbol = symbol.replace("-", "");
    if (this.props.match.params.exchangetype === "BINANCE") {
      this._connectSocketStreams(this.streams.map((i) => `${symbol}${i}`));
      fetch(
        `https://api.binance.com/api/v1/aggTrades?limit=${10}&symbol=${symbolType}`
      )
        .then((response) => response.json())
        .then((response) => {
          this.props.dispatch({
            type: "SET_TRADES",
            data: response,
          });
          this.setState({
            isLoaded: true,
            loadedTrades: true,
          });
        })
        .catch((error) => {
          this.setState({
            isLoaded: false,
            error: error,
          });
        });
      fetch(
        `${baseUrl}api/crpto-price?symbol=${symbol}&&exchnageType=${exchangeType}`
      )
        .then((response) => response.json())
        .then((response) => {
          console.log("response.price====LLKKII", response.price);
          this.setState({ currentprice1: response.price });
        })
        .catch();
    }
    this.getData();
  }

  componentWillUnmount() {
    //clearInterval();
    var getSocket = this.state.socketCollect;
    getSocket.emit("disconnectExchangeApi");
    let symbol = this.state.pairType.toLowerCase();
    symbol = symbol.replace("-", "");
    this._disconnectSocketStreams(this.streams.map((i) => `${symbol}${i}`));
  }

  componentWillReceiveProps(nextProps) {
    let collectThis = this;
    if (
      nextProps.orderdata.order &&
      nextProps.orderdata.order.data &&
      nextProps.orderdata.order.data.message != ""
    ) {
      console.log("messageREceive==", nextProps.orderdata.order.data.message);
      axios
        .post(
          baseUrl + "api/getLeaderBoardWithOrderData",
          { contestId: this.state.contestId },
          config
        )
        .then((res1) => {
          collectThis.setState({
            leaderboard: res1.data.data,
            leaderboardPaticipants: res1.data.data,
          });
        })
        .catch();
      axios
        .post(
          baseUrl + "api/getOrderByIdDataApi",
          { contestId: this.state.contestId, contestType: "coin" },
          config
        )
        .then((res1) => {
          collectThis.setState({
            getOrderByIdData: res1.data.data,
          });
        })
        .catch();
    }
    // if(this.state.tempArrPair !='' && this.state.flagPairData==1){
    //     this.setState({flagPairData:'2'});
    //     var pair_idArr = this.state.tempArrPair.split(",");
    //     axios.post(baseUrl+"api/pairById-data", { id: pair_idArr},config)
    //     .then(res1 => {
    //         this.setState({ pair: res1.data.data });
    //     }).catch()
    // }
  }
  openTradingChart = (symbol) => (
    <TradingViewWidget
      symbol={
        this.props.match.params.exchangetype + ":" + symbol.replace("-", "")
      }
      theme={Themes.LIGHT}
      locale="en"
      autosize={true}
      details={true}
    />
  );
  showTimerCounterHtml = () => {
    // if (this.state.contestId != '' && this.state.contestId != undefined) {
    if (!isNaN(this.state.days)) {
      return (
        <span className="header_timer">
          {this.state.days}
          <span>Day </span>
          {this.state.hours}
          <span>Hr </span>
          {this.state.minutes}
          <span>Min </span>
          {this.state.seconds}
          <span>Sec </span>
          Left
        </span>
      );
    }
    // }
  };
  showHtml = () => {
    let counts = this.state.getOrderByIdData.length;

    const html = [];
    if (counts > 0) {
      var classThis = this;
      this.state.getOrderByIdData.map(function (value, i) {
        let utcMoment =
          value.updatedDate !== null
            ? moment(value.updatedDate)
            : moment(value.createdDate);
        html.push(
          <>
            <tr>
              <td>{value.coinName}</td>
              <td>{value.marketPrice}</td>
              <td>{value.predictionPrice}</td>
              <td
                className={
                  value.bidType == "up" ? "bid-type up" : "bid-type down"
                }
              >
                {value.bidType.toUpperCase()}
              </td>
              <td>{utcMoment.format("DD-MM-YYYY hh:mm:ss a")}</td>
            </tr>
          </>
        );
      });
    } else {
      html.push(<div className="text-center">No Record Found</div>);
    }
    return html;
  };

  showParticipantsHtml = () => {
    var html = [];
    // console.log("this.state.leaderboard.length=",this.state.leaderboard.length)
    if (this.state.leaderboard.length > 0) {
      this.state.leaderboard.map(function (value, i) {
        let utcMoment = "";
        let utcDateTimeValue =
          value.predictedUpdateTime !== null
            ? value.predictedUpdateTime
            : value.predictedTime;
        if (utcDateTimeValue !== null) {
          utcMoment = moment(utcDateTimeValue).format(
            "DD-MM-YYYY hh:mm:ss:SSS a"
          );
          // moment(value.updatedDate).format('YYYY-MM-DD hh:mm:ss')
        }
        var rowColor = value.order_count >= 1 ? "#01aa78" : "#eb6a61";
        html.push(
          <tr style={{ color: rowColor }}>
            <td className="col-3 ">{i + 1}</td>
            <td className="col-3 ">{utcMoment}</td>
            <td className="col-3 ">{value.name}</td>
            <td className="col-3 ">
              {value.mobile.replace(/\d(?=\d{4})/g, "*")}
            </td>
            <td className="col-3 ">{value.predictionPrice}</td>
          </tr>
        );
      });
    }
    return html;
  };
  render() {
    const { error, isLoaded } = this.state;
    const url = window.location.href;
    var lastSegment1 = url.split("/").pop();
    var lastSegment2 = lastSegment1.split("?");
    var lastSegment = lastSegment2[0];
    if (error) {
      return <div className="alert alert-danger"></div>;
    }
    if (!isLoaded) {
      return <Loading themeSet={this.state.themeSet} />;
    }
    return (
      <>
        {/* <MetaTags>
                    <meta NAME="robots" CONTENT="noindex,nofollow" />
                </MetaTags> */}

        <Navbar
          serverTime={this.state.serverTime}
          contestProfolioByUserData={this.state.contestProfolioByUserData}
          symbol={this.state.symbol}
          urlPath={true}
          endDate={this.state.records.endDate}
          endTime={this.state.records.endTime}
          virtualFundassign={this.state.virtualFundassign}
          {...this.props.ticker}
          virtualFund={this.state.virtualFund}
          portfoliototal={this.state.portfoliototal}
          contestType="price"
        />
        <Sidebar />
        <div className="dashbord_manbox ">
          <div className="contest-name-outer">
            <h4>
              Predict Price Trend({this.state.records.contestName})
              <div className="pool_amount_box ml-auto">
                <div className="">Pool Amount:</div>
                <div className="ml-4">
                  {this.state.records.entryFeePoints *
                    this.state.leaderboard.length}
                </div>
              </div>
              {this.showTimerCounterHtml()}
            </h4>
            {/* {this.state.contestId != '' && this.state.contestId != undefined ? 
                        {
                            !isNaN(this.state.days) &&
                            <p className="header_timer">
                                {Number(this.state.days)}
                                <span>Day </span>
                                {Number(this.state.hours)}
                                <span>Hr </span>
                                {Number(this.state.minutes)}
                                <span>Min </span>
                                {Number(this.state.seconds)}
                                <span>Sec </span>
                                Left
                            </p>
                        } */}
            {/* :<h4>wait for response..</h4> */}
          </div>
          <div className="container-fluid">
            <div className="row sm-gutters row_d">
              <div className="col-md-8 col_d">
                {/*  <div className="kline-para kline-para-basic mt-0 mt-md-3 crypt-market-status ">
                                    <div className="box-kline-para-basic-left">
                                        <span className="productSymbol has-info ng-scope">
                                            <strong className="ng-binding text-danger">
                                                EXCHANGE {this.state.exchangeType}
                                            {this.state.symbol.slice(0, -4)}/{this.state.symbol.slice(-4)} 
                                            </strong>
                                            <span className="aero_icon" data-toggle="collapse" data-target="#demo11"><i className="las la-minus"></i></span>
                                            <font className="ng-binding"> / BTC</font> 
                                          <div className="info-box">
                                                dfsdfsd
                                            </div> 
                                        </span>
                                    </div>
                                 {loadedTicker ? <Ticker {...this.props.ticker} /> : <Loading themeSet={this.state.themeSet}/>} 
                                    {loadedTicker ? (this.props.match.params.exchangetype === 'BINANCE' ? <Ticker {...this.props.ticker} /> : <ExchangeTypeTicker {...this.props.ticker} />) : <Loading themeSet={this.state.themeSet} />}
                                    <div className="cls"></div>
                                </div>*/}
                <div className="row sm-gutters row_d">
                  {/*  {loadedDepth ? <ProfitLoseTable record={this.state.records} bids={this.props.depth.bids} asks={this.props.depth.asks} {...this.props.ticker} /> : <Loading themeSet={this.state.themeSet} />}
                                 
*/}
                </div>
                <div className="crypt-market-status crypt-market-status22 mt-2 chart">
                  <div className="p-2 w_none">
                    <button
                      className="btn w100 view_dital "
                      data-toggle="collapse"
                      data-target="#demo23"
                    >
                      View Chart
                    </button>
                  </div>
                  <div id="demo23" className="collapse w_block">
                    {this.openTradingChart(this.props.match.params.symbol)}
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-4  col_d mt-2">
                {/* <OrderSection getCurrencyValueData={this.state.getCurrencyValueData}  {...this.props.ticker} currentprice={this.state.currentprice1} virtualFund={this.state.virtualFund} contestName={this.state.records.contestName} pairs={this.state.pair} urldummy={baseUrl}/> */}
                {/* Buy order */}
                <div className="crypt-market-status  h95">
                  <div className="crypt-boxed-area">
                    <ul className="w_none nav nav-tabs" id="crypt-tab">
                      <li>
                        <a
                          className="active pl-4 pr-4"
                          data-toggle="tab"
                          href="#buy_tab"
                        >
                          Buy
                        </a>
                      </li>
                      <li>
                        <a
                          className="pl-4 pr-4"
                          data-toggle="tab"
                          href="#sell_tab"
                        >
                          Sell
                        </a>
                      </li>
                    </ul>
                    <div className="row no-gutters tab-content">
                      <PredictionBuyOrder
                        usdt="0"
                        currentprice={this.state.currentprice1}
                        contestData={this.state.records}
                        orderPredictionData={this.state.getOrderByIdData}
                      />
                    </div>
                  </div>
                  <Toaster position="bottom-right" reverseOrder={false} />
                </div>
                {/* Buy order End */}
              </div>

              <div className="col-md-6 col_d mt-3 exchange_orders">
                <div className="crypt-market-status market-status-outer">
                  <div>
                    <ul className="nav nav-tabs">
                      <li role="presentation">
                        <a
                          href="#OpenOrders"
                          className="active"
                          data-toggle="tab"
                          onClick={() => this.tabClick("Open Orders")}
                        >
                          Your Bid
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div
                        role="tabpanel"
                        className="tab-pane active"
                        id="OpenOrders"
                      >
                        <div className="table_overflow_new">
                          <table className="table border_none">
                            <tr>
                              <th scope="col">Coin Name</th>
                              <th scope="col">Current Price</th>
                              <th scope="col">Prediction Price</th>
                              <th scope="col">Bid Type</th>
                              <th scope="col">Date</th>
                            </tr>
                            <tbody>{this.showHtml()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-6  col_d mt-3">
                <div className="crypt-market-status">
                  {/* <PairSection {...this.props.ticker} pairs={this.state.pair} urldummy={baseUrl} />
                                <MarketTrade leaderboard={this.state.leaderboard} virtualFund={this.state.virtualFundassign} trades={this.props.trades} record={this.state.allCloseOrder} {...this.props.ticker} contestType={this.state.records.contestType}/> 
                                 <MarketActivities record={this.state.records} /> */}
                  <ul className="nav nav-tabs nav-tabs5" id="crypt-tab">
                    <li role="presentation">
                      <a
                        className="active show"
                        href="#MarketTradesParticipants"
                        data-toggle="tab"
                        onClick={() => this.tabClick("Participants")}
                      >
                        Participants
                      </a>
                    </li>
                  </ul>
                  <div
                    role="tabpanel"
                    className="tab-pane"
                    id="MarketTradesParticipants"
                  >
                    <div className="table_overflow_new">
                      <div className="table-responsive">
                        <table className="table border_none mb-0">
                          <thead>
                            <tr>
                              {/* <th className="col-4">Price(USDT)</th>
                                    <th className="col-4">Amount({props.curruncyName})</th>

								<th className="col-4 tr">Time</th>*/}
                              <th className="col-3">Sr No.</th>
                              <th scope="col">Predicted Time</th>
                              <th className="col-3">User</th>
                              <th className="col-3">Mobile</th>
                              <th className="col-3">Predicted Price</th>
                            </tr>
                          </thead>
                          <tbody className="crypt-table-hover">
                            {this.showParticipantsHtml()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <OrderHistory getOrderByIdData={this.state.getOrderByIdData} virtualFund={this.state.virtualFund} record={this.state.records}  {...this.props.ticker} currentprice={this.state.currentprice1} allAccount={this.state.allAccount} allCloseOrder={this.state.allCloseOrder} /> */}
        </div>
        <Footer />
      </>
    );
  }
}

PridictionExchange.propTypes = {
  auth: PropTypes.object.isRequired,
  contestdata: PropTypes.object.isRequired,
  orderdata: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  contestdata: state.contestdata,
  orderdata: state.orderdata,
  records: state.records,
});

export default connect((state) => state)(PridictionExchange);
